<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      outlined
      :clearable="clearable"
      @input="$emit('input', $event !== '' ? $event : null)"
      :multiple="multiple"
      :itemText="itemText"
      :itemValue="itemValue"
      :returnObject="returnObject"
      :filled="filled || readonly"
      :readonly="readonly"
  >
  </v-select>
</template>

<script>

export default {
  name: 'CommonFieldSelect',
  inheritAttrs: false,
  props: {
    clearable: {default: false},
    returnObject: {default: false},
    itemText: {default: null},
    itemValue: {default: null},
    multiple: {default: false},
    readonly: {default: false},
    filled: {default: false},
    items: {default: function() {return []}},
  },

  components: {},

  computed: {
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
